import { Grid, Typography } from "@material-ui/core";
import moment from "moment/moment";
import { useEspelhoFaturamentoService } from "../../context/EspelhoFaturamentoContext";

export const ReportHeader = () => {
  const { cachedInvoicing, filters } = useEspelhoFaturamentoService();

  const { period } = cachedInvoicing;
  const startDate = moment(
    period?.startDate,
    filters.period === "YYYY-MM-DD"
  ).format("DD/MM/YYYY");
  const endDate = moment(
    period?.endDate,
    filters.period === "YYYY-MM-DD"
  ).format("DD/MM/YYYY");

  return (
    <Grid item xs>
      <Typography variant="h4">Relatório de Espelho de Faturamento</Typography>

      <Typography variant="subtitle2">
        Período da busca: {startDate} e {endDate}
      </Typography>
    </Grid>
  );
};
